import { ManufacturerService } from 'src/app/services/manufacturer/manufacturer.service';

export class Manufacturer {
  id: string;
  name: string;
  public constructor(init?: Partial<Manufacturer>) {
    Object.assign(this, init);
  }
}
